import NotQualifiedScreen from 'features/lineOfCredit/screens/notQualified/NotQualifiedScreen';
import React from 'react';

export default function Page() {
  return <NotQualifiedScreen />;
}
